import React from "react";
import "../css/ProjectShare.css";

function BannerPSShimmer() {
  return <div className="banner-ps skeleton"></div>;
}

export default BannerPSShimmer;
